"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIndexersWithProjects = exports.GetIndexers = exports.GetIndexer = exports.IndexerFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.IndexerFields = (0, graphql_tag_1.default) `
  fragment IndexerFields on Indexer {
    id
    controller
    commission
    totalStake
    maxUnstakeAmount
    capacity
    metadata {
      metadataCID
      name
      url
    }
  }
`;
exports.GetIndexer = (0, graphql_tag_1.default) `
  query GetIndexer($address: String!) {
    indexer(id: $address) {
      ...IndexerFields
    }
  }
  ${exports.IndexerFields}
`;
exports.GetIndexers = (0, graphql_tag_1.default) `
  query GetIndexers($first: Int, $offset: Int, $order: IndexersOrderBy = ID_ASC) {
    indexers(
      first: $first
      offset: $offset
      orderBy: [$order]
      filter: { active: { equalTo: true } }
    ) {
      totalCount
      nodes {
        ...IndexerFields
      }
    }
  }
  ${exports.IndexerFields}
`;
exports.GetIndexersWithProjects = (0, graphql_tag_1.default) `
  query GetIndexersWithProjects($offset: Int, $order: IndexersOrderBy = ID_ASC) {
    indexers(
      first: 100
      offset: $offset
      orderBy: [$order]
      filter: { active: { equalTo: true } }
    ) {
      totalCount
      nodes {
        ...IndexerFields
        projects {
          nodes {
            deploymentId
            status
          }
        }
      }
    }
  }
  ${exports.IndexerFields}
`;
//# sourceMappingURL=indexers.generated.js.map